module.exports = __webpack_public_path__ + "static/media/6.bd3448cb.jpg";